/* eslint-disable import/no-anonymous-default-export */
export default {
  mutation: `mutation createFarms($farms: [CreateFarmData]) {
        createFarms(farms: $farms)
    }`,
};
